import { Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { COLORS } from '../../../../utils/colors';
import { Trash, X } from 'phosphor-react';
import { SupplierJobApiResponse } from '@dill/dill-shared/dist/src';
import { twMerge } from 'tailwind-merge';
import { AppButton } from '../../../general/AppButton/AppButton';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { mergeSupplierJobs } from '../../../../redux/services/supplierJobsService';
import { openMessageModal } from '../../../../redux/globalSlices/genericSlice';

function MergeSupplierJobsModal({
  open,
  selectedSupplierJobs,
  handleClose,
}: {
  open: boolean;
  selectedSupplierJobs: SupplierJobApiResponse[];
  handleClose: (isRefresh?: boolean) => void;
}) {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const [selectedJobToMergeInto, setselectedJobToMergeInto] =
    useState<SupplierJobApiResponse | null>(null);

  const [supplierJobs, setSupplierJobs] = useState<SupplierJobApiResponse[]>([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [isErrorExist, setErrorExist] = useState(false);
  useEffect(() => {
    if (selectedSupplierJobs && open) {
      const sortedJobs = [...selectedSupplierJobs].sort((itemA, itemB) => {
        if (itemA.buyer && itemB.buyer && itemA.buyer?.name > itemB.buyer?.name) {
          return 1;
        } else if (itemA.buyer && itemB.buyer && itemA.buyer?.name < itemB.buyer?.name) {
          return -1;
        } else {
          return 0;
        }
      });
      setSupplierJobs([...sortedJobs]);
    }
  }, [selectedSupplierJobs, open]);

  useEffect(() => {
    if (!open) {
      setErrorMessage('');
      setselectedJobToMergeInto(null);
      setErrorExist(false);
      setSupplierJobs([]);
    }
  }, [open]);

  const checkErrors = () => {
    let isError = false;
    const customersMap: { [x: string]: string } = {};
    supplierJobs.forEach((job) => {
      if (job.buyer?.id) {
        customersMap[job.buyer?.id] = job.buyer?.id;
      }
    });
    if (supplierJobs.length < 2) {
      setErrorMessage('Jobs to merge must be greater than two.');
      isError = true;
    } else if (Object.keys(customersMap).length > 1) {
      setErrorMessage('Jobs to merge must belong to the same customer.');
      isError = true;
    } else {
      setErrorMessage('');
    }
    setErrorExist(isError);
    return isError;
  };

  useEffect(() => {
    if (supplierJobs) {
      checkErrors();
    }
  }, [supplierJobs]);

  const handleRemoveSupplierJob = (jobId: string) => {
    setSupplierJobs(supplierJobs.filter((job) => job.id !== jobId));
    if (jobId === selectedJobToMergeInto?.id) {
      setselectedJobToMergeInto(null);
    }
  };

  const handleMergeJobs = async () => {
    if (!selectedJobToMergeInto) {
      return;
    }
    if (isErrorExist) {
      return;
    }
    const supplierJobIdsToMerge = supplierJobs.reduce((jobIds: string[], job) => {
      if (job.id !== selectedJobToMergeInto.id) {
        return [...jobIds, job.id];
      }
      return jobIds;
    }, []);
    const result = await dispatch(
      mergeSupplierJobs({
        supplierId: currentSupplier?.id || '',
        supplierJobIdsToMerge,
        supplierJobIdToMergeInto: selectedJobToMergeInto.id,
      })
    );
    console.log({ result });
    if (result.type === 'supplierJobs/mergeSupplierJobs/fulfilled') {
      handleClose(true);
    } else {
      let errorMsg = '';
      if (result.type === 'supplierJobs/mergeSupplierJobs/rejected') {
        errorMsg = result.payload as any;
      }
      dispatch(
        openMessageModal({
          buttonText: 'Close',
          modalType: 'ERROR',
          title: 'Error merging jobs',
          subTitle: errorMsg,
          onClose: () => {
            // handleClose();
          },
        })
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex min-h-40 w-[50vw] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg  flex-col px-5 py-1">
        <div className="sticky top-0 z-10 bg-white py-2">
          <X
            size={20}
            className="absolute right-0 top-3 cursor-pointer"
            color={COLORS.GREY_500}
            onClick={() => {
              handleClose();
            }}
          />
          <h3 className="text-lg font-bold ">Merge Jobs</h3>
        </div>

        <div className=" ">
          <p className="text-xs ">Select Job to merge other jobs into</p>
          <div className="max-h-60 overflow-y-scroll  flex w-full flex-wrap mb-2 py-1">
            {supplierJobs.map((supplierJob, i) => {
              return (
                <div key={`${i}o`} className="flex p-1.5 w-1/3 ">
                  <div
                    className={twMerge(
                      'border-[0.4px]  flex p-1 rounded-lg shadow-md w-full h-full cursor-pointer',
                      selectedJobToMergeInto?.id === supplierJob.id ? 'bg-slate-400 text-white' : ''
                    )}
                    onClick={() => {
                      setselectedJobToMergeInto(supplierJob);
                    }}>
                    <div className="flex flex-col w-full">
                      <p className="text-xs font-bold mb-1">{supplierJob.name}</p>

                      <div className="">
                        {supplierJob.providerJobId && currentSupplier?.domainId === 'topgun' && (
                          <p className="text-2xs mb-0.5">
                            <span className="font-bold">Comment:</span>
                            <span>{` ${supplierJob.buyer?.name}`}</span>
                          </p>
                        )}
                        <p className="text-2xs">
                          <span className="font-bold">Customer:</span>
                          <span>{` ${supplierJob.buyer?.name}`}</span>
                        </p>
                      </div>
                    </div>

                    <Trash
                      color={
                        selectedJobToMergeInto?.id === supplierJob.id
                          ? COLORS.WHITE
                          : COLORS.ERROR_500
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveSupplierJob(supplierJob.id);
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          {selectedJobToMergeInto && (
            <div className=" mt-2">
              <p className="text-xs mb-1">Selected Job into which other jobs will be merged</p>
              <div className=" flex-col flex py-1 px-2 rounded-lg shadow-md w-2/3 h-full cursor-pointer bg-blue-500 text-white">
                <p className="text-lg font-bold mb-1">{selectedJobToMergeInto.name}</p>
                <div className="">
                  {selectedJobToMergeInto.providerJobId &&
                    currentSupplier?.domainId === 'topgun' && (
                      <p className="text-sm mb-0.5">
                        <span className="font-bold">Comment:</span>
                        <span>{` ${selectedJobToMergeInto.buyer?.name}`}</span>
                      </p>
                    )}
                  <p className="text-sm">
                    <span className="font-bold">Customer:</span>
                    <span>{` ${selectedJobToMergeInto.buyer?.name}`}</span>
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className=" mt-2">
            <p className="text-xs text-red-500">{errorMessage}</p>
          </div>

          <div className="flex gap-2 mt-2 justify-end">
            <AppButton
              text="Close"
              type="SECONDARY"
              onClick={() => {
                handleClose();
              }}
            />
            <AppButton
              text="Submit"
              type="PRIMARY"
              onClick={() => {
                handleMergeJobs();
              }}
              buttonStyles={{ width: '100px', height: '40px' }}
              isDisabled={!selectedJobToMergeInto || isErrorExist}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default MergeSupplierJobsModal;
